import '../styles/InvestorUpdates.scss'
import {useIntl} from 'react-intl'
import {Dropdown, Pagination, Table} from 'react-bootstrap'
import {useEffect, useState} from 'react'
// import {InvestorUpdatesModel} from '../core/_models'
import {useAuth} from '../../auth'
import {
  deleteInvestorUpdateAPI,
  editInvestorUpdatesAPI,
  getAllInvestorUpdatesAPI,
} from '../core/_request'
import {useDateFormat} from '../../../hooks/useDateFormat'
import {DateTime} from 'luxon'
import {toast} from 'react-toastify'
// import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import {useInvestorDatabase} from '../../investor-database/core/InvestorContext'
import {useNavigate} from 'react-router-dom'
// import {Spinner} from '../../widgets/components/General/Spinner'
// import NoDataPage from '../../widgets/components/NoDataPage'
import {DeleteConfirmationModal} from '../views/DeleteConfirmationModal'
import {roleValues} from '../../../core/_constants'
import {OverlayTrigger} from 'react-bootstrap'
import {Tooltip} from 'react-bootstrap'
import {GET_FILE_URL} from '../../onboarding/core/_requests'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import SkeletonLoader from './SkeletonLoader'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'

export const InvestorUpdates = () => {
  const {companyId, role, currentUser} = useAuth()
  const [activePage, setActivePage] = useState(1)
  const [totalPages, setTotalPages] = useState<number>()
  const {searchInvestorUpdate, investorUpdateStatusFilter} = useInvestorDatabase()
  const {getDateValue} = useDateFormat()
  const navigate = useNavigate()
  // const [showKebabMenu, setShowKebabMenu] = useState(false)
  const {formatMessage} = useIntl()
  const [investorUpdatesData, setInvestorUpdatesData] = useState<any>([])
  const [getApiLoading, setApiLoading] = useState(false)

  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [investorDeleteId, setInvestorDeleteId] = useState<number>()

  const renderSkeletonRows = () => {
    const skeletonRows = []
    for (let i = 0; i < 8; i++) {
      skeletonRows.push(
        <tr className='' key={i}>
          <td colSpan={8}>
            <SkeletonLoader />
          </td>
        </tr>
      )
    }
    return skeletonRows
  }

  const getAllInvestorUpdate = async () => {
    try {
      // if (
      //   companyId &&
      //   role &&
      //   (role === roleValues.OWNER || role === roleValues.ADMIN || role === roleValues.IRM)
      // ) {

      if (companyId && role && role === roleValues.OWNER) {
        setApiLoading(true)
        const {
          data: {
            data: {investorUpdates, totalCount},
            success,
            errors,
          },
        }: any = await getAllInvestorUpdatesAPI(
          +companyId!,
          activePage,
          10,
          '',
          searchInvestorUpdate,
          investorUpdateStatusFilter
        )
        if (success) {
          setTotalPages(Math.ceil(totalCount / 10))
          setInvestorUpdatesData([...investorUpdates])
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setApiLoading(false)
    }
  }
  useEffect(() => {
    getAllInvestorUpdate()
  }, [companyId, searchInvestorUpdate, activePage, investorUpdateStatusFilter, role]) // eslint-disable-line react-hooks/exhaustive-deps

  const onEditInvestorUpdate = async (updateId: number, status: string) => {
    try {
      const {
        data: {data: editedData, success},
      } = await editInvestorUpdatesAPI(updateId, {status: status})
      if (success) {
        await getAllInvestorUpdate()
        toast.success(formatMessage({id: `Successfully update to ${editedData?.status}`}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.EditInvestorUpdatesStatusSuccessful,
            action: 'normal',
            metadata: {
              investor_update_id: updateId!,
              status: status,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
            },
          },
        })
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.EditInvestorUpdatesStatusFailed,
          action: 'normal',
          metadata: {
            investor_update_id: updateId!,
            status: status,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            error: err,
          },
        },
      })
    }
  }
  const deleteInvestorUpdate = async (investorUpdateId: number) => {
    try {
      setDeleteLoading(true)
      const {
        data: {success},
      }: any = await deleteInvestorUpdateAPI(+investorUpdateId)
      if (success) {
        setDeleteShowModal(false)
        setInvestorDeleteId(undefined)
        await getAllInvestorUpdate()
        toast.success(formatMessage({id: 'Successfully deleted investor update'}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DeleteInvestorUpdatesSuccessful,
            action: 'normal',
            metadata: {
              investor_update_id: investorUpdateId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
            },
          },
        })
      }
    } catch (err) {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DeleteInvestorUpdatesFailed,
          action: 'normal',
          metadata: {
            investor_update_id: investorUpdateId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            error: err,
          },
        },
      })
    } finally {
      setDeleteLoading(false)
    }
  }
  const row = investorUpdatesData?.map((investorUpdate: any) => (
    <tr className='table-tbody-row border-dark-mode' key={investorUpdate.updateId}>
      <td>{investorUpdate.title}</td>
      <td>
        {investorUpdate.createdAt
          ? getDateValue(new Date(investorUpdate.createdAt).toISOString()?.toString())
            ? getDateValue(new Date(investorUpdate.createdAt).toISOString()?.toString())
            : DateTime.fromISO(
                new Date(investorUpdate.createdAt).toISOString()?.toString()
              ).toLocaleString(DateTime.DATE_MED)
          : '-'}{' '}
      </td>
      <td>
        <OverlayTrigger
          placement='bottom'
          overlay={
            <Tooltip id='tooltip'>
              <p className='m-0'>
                {investorUpdate?.user?.firstName} {investorUpdate?.user?.lastName}
              </p>
            </Tooltip>
          }
        >
          <img
            src={
              investorUpdate?.user?.file?.name
                ? `${GET_FILE_URL}/${encodeURIComponent(investorUpdate?.user?.file?.name || '')}`
                : toAbsoluteUrl('/media/icons/duotune/general/user1.svg')
            }
            height='20'
            width='20'
            alt='user'
            style={{objectFit: 'contain'}}
            className='ms-5'
          />
        </OverlayTrigger>
      </td>
      <td>
        <span
          className={`badge ${
            investorUpdate.status === 'DRAFT'
              ? 'draft-badge'
              : investorUpdate.status === 'PUBLISHED'
              ? 'publish-badge'
              : investorUpdate.status === 'UNPUBLISHED'
              ? 'in-progress-badge'
              : ''
          }`}
        >
          {investorUpdate.status}
        </span>
      </td>
      <td>{investorUpdate.clicks}</td>
      <td>{investorUpdate.views}</td>
      <td>
        <span
          className={`badge ${
            investorUpdate.type === 'INTERNAL'
              ? 'internal-badge'
              : investorUpdate.type === 'EXTERNAL'
              ? 'external-badge'
              : ''
          }`}
        >
          {investorUpdate?.type}
        </span>
      </td>
      <td>
        <div className='dropdown-container'>
          <Dropdown align={'end'} drop='end'>
            <Dropdown.Toggle className='bi bi-three-dots-vertical p-1'></Dropdown.Toggle>
            <Dropdown.Menu className='m-2'>
              <Dropdown.Item className='text-dark ps-5'>
                <p
                  className='mb-0'
                  onClick={() => {
                    window.open(`/updates/preview/${investorUpdate.updateId}`, '_blank')
                  }}
                >
                  {formatMessage({id: 'View'})}
                </p>
              </Dropdown.Item>
              <Dropdown.Item className='text-primary ps-5'>
                {investorUpdate.status === 'DRAFT' ? (
                  <p
                    className='mb-0'
                    onClick={() => onEditInvestorUpdate(investorUpdate.updateId, 'PUBLISHED')}
                  >
                    {formatMessage({id: 'Publish'})}
                  </p>
                ) : (
                  <p
                    className='mb-0'
                    onClick={() => onEditInvestorUpdate(investorUpdate.updateId, 'DRAFT')}
                  >
                    {formatMessage({id: 'Unpublish'})}
                  </p>
                )}
              </Dropdown.Item>
              <Dropdown.Item className='text-dark ps-5'>
                <p
                  className='mb-0'
                  onClick={() => {
                    navigate(`/updates/create-update/${investorUpdate.updateId}`)
                  }}
                >
                  {formatMessage({id: 'Edit'})}
                </p>
              </Dropdown.Item>

              <Dropdown.Item
                className='text-danger ps-5'
                onClick={() => {
                  setDeleteShowModal(true)
                  setInvestorDeleteId(investorUpdate.updateId)
                }}
              >
                <p className='mb-0'>{formatMessage({id: 'Delete'})}</p>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </td>
    </tr>
  ))

  const paginationItems = []

  for (let number = 1; number <= totalPages!; number++) {
    paginationItems.push(
      <Pagination.Item
        key={number}
        active={number === activePage}
        onClick={() => setActivePage(number)}
      >
        {number}
      </Pagination.Item>
    )
  }

  return (
    <>
      <div className='investor-updates-container'>
        <div className='card row'>
          <div className='card-body'>
            <div className='table table-responsive h-100'>
              <Table className='w-100'>
                <thead className='custom-thead'>
                  <tr className='font-size-12 font-weight-400 table-row border-dark-mode'>
                    <td className='min-w-100px'>{formatMessage({id: 'Title'})}</td>
                    <td className='min-w-100px'>{formatMessage({id: 'Created On'})}</td>
                    <td className='min-w-100px'>{formatMessage({id: 'Published By'})}</td>
                    <td className='min-w-100px'>{formatMessage({id: 'Status'})}</td>
                    <td className='min-w-100px'>{formatMessage({id: 'Click Counts'})}</td>
                    <td className='min-w-100px'>{formatMessage({id: 'View Count'})}</td>
                    <td className='min-w-100px'>{formatMessage({id: 'Update Type'})}</td>
                    <td className='min-w-100px'>{formatMessage({id: 'Actions'})}</td>
                  </tr>
                </thead>
                <tbody>
                  {getApiLoading ? (
                    renderSkeletonRows()
                  ) : !getApiLoading && investorUpdatesData?.length === 0 ? (
                    <tr>
                      <td colSpan={8}>
                        <div
                          className={`d-flex align-items-center justify-content-center flex-column text-center `}
                          style={{
                            marginTop: '10%',
                          }}
                        >
                          <div style={{order: 1}}>
                            <img
                              src={toAbsoluteUrl('/media/icons/investor-updates/NoDataImg.svg')}
                              alt='no-data-img'
                              height={200}
                              width={200}
                            />
                          </div>
                          <div className='w-100' style={{order: 2}}>
                            <div>
                              <h1>{formatMessage({id: 'Nothing to show'})}</h1>

                              <p className='w-100 px-10'>
                                {formatMessage({
                                  id: "Currently we don't have anything to show here",
                                })}
                              </p>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    row
                  )}
                </tbody>
              </Table>
              {!getApiLoading && investorUpdatesData?.length > 0 ? (
                <div className='w-100 d-flex flex-end'>
                  <Pagination>
                    <Pagination.First
                      key='first'
                      disabled={activePage === 1}
                      onClick={() => setActivePage(1)}
                    />
                    <Pagination.Prev
                      key='prev'
                      disabled={activePage === 1}
                      onClick={() => setActivePage(activePage - 1)}
                    />

                    {paginationItems}
                    <Pagination.Next
                      key='next'
                      disabled={activePage === totalPages}
                      onClick={() => setActivePage(activePage + 1)}
                    />
                    <Pagination.Last
                      key='last'
                      disabled={activePage === totalPages}
                      onClick={() => setActivePage(paginationItems.length - 1)}
                    />
                  </Pagination>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <DeleteConfirmationModal
        setDeleteShowModal={setDeleteShowModal}
        showDeleteModal={showDeleteModal}
        onDeleteSubmit={deleteInvestorUpdate}
        deleteLoading={deleteLoading}
        investorDeleteId={investorDeleteId}
      />
    </>
  )
}
